import { ref, onMounted } from 'vue'

/**
 * Composable to check if user has download permission
 * Reads from localStorage 'can_download' value
 */
export function useDownloadPermission() {
    const canDownload = ref<boolean>(false)

    const checkDownloadPermission = () => {
        const permission = localStorage.getItem('can_download')
        canDownload.value = permission === 'true'
        return canDownload.value
    }

    // Check permission on mount
    onMounted(() => {
        checkDownloadPermission()
    })

    return {
        canDownload,
        checkDownloadPermission
    }
}
